import { io } from "socket.io-client";
import { API_BASE } from "../api/api";

let notificationSocket = null;

const namespaceUrl = `${API_BASE}/notifications`;

export function getNotificationSocket({ token } = {}) {
  if (notificationSocket && notificationSocket.connected) {
    return notificationSocket;
  }

  if (!notificationSocket) {
    notificationSocket = io(namespaceUrl, {
      transports: ["websocket"],
      withCredentials: true,
      auth: token ? { token } : undefined,
    });
  } else if (!notificationSocket.connected) {
    notificationSocket.auth = token ? { token } : undefined;
    notificationSocket.connect();
  }

  return notificationSocket;
}

export function disconnectNotificationSocket() {
  if (notificationSocket) {
    notificationSocket.disconnect();
    notificationSocket = null;
  }
}
